import React from 'react'
import { Icon } from '../../../../../atoms/Icon'
import {
  Card,
  CardHeader,
  CardTitle,
} from '../../../BuildingCharacteristics.styles'
import type { NoDataCardProps } from '../NeighborhoodContextTab.types'

export const NoDataCard: React.FC<NoDataCardProps> = ({ t }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>
          <Icon name="map-pin" size="small" />
          {t('neighborhood.title')}
        </CardTitle>
      </CardHeader>
      <div
        style={{
          padding: '60px 20px',
          textAlign: 'center',
          color: '#999',
          fontSize: '14px',
        }}
      >
        {t('neighborhood.noData')}
      </div>
    </Card>
  )
}
